import React from "react"
import Layout from "../../components/_App/layout"
import GraduateStudentsPage from "../../components/AssistPage/FirstDepartment/GraduateStudentsPage"
import Seo from "../../components/_App/seo"
import Navbar from "../../components/_App/NavbarFirstDepartment"

import Footer from "../../components/_App/Footer"
import PageBanner from "../../components/Common/PageBanner"
import { graphql } from "gatsby"
import { useTranslation } from 'gatsby-plugin-react-i18next';
//import {useLocales} from '../components/_App/hook'
export const query = graphql`
query ($language: String!) {
  locales: allLocale(filter: {language: {eq: $language}}) {
    edges {
      node {
        ns
        data
        language
      }
    }
  }
}
`;



const GraduateStudents = () => {
  // const localeD=useLocales()
  const { t } = useTranslation();


  return (
    <Layout>
      <Navbar />

      <PageBanner pageTitle={t("Graduate students")} />

      <GraduateStudentsPage />



      <Footer />
    </Layout>
  )
}

export const Head = () => <Seo title="Graduate Students" />

export default GraduateStudents
